/* eslint-disable @typescript-eslint/no-explicit-any */
import { Ref, toRef } from '@nuxtjs/composition-api';

import { IClusterCalculatorDefinition } from '../../types/cluster/IClusterCalculatorDefinition';
import { IClusterDomInfo } from '../../types/cluster/IClusterDomInfo';
import IGoogleMapPosition from '../../types/IGoogleMapPosition';
import IMapEventListenerParams from '../../types/IMapEventListenerParams';
import IMapSzukajServiceConfig from '../../types/IMapSzukajServiceConfig';
import { BloczekMarker } from '../../types/marker/BloczekMarker';
import IMarkerIcon from '../../types/marker/IMarkerIcon';
import IMarkerInfo from '../../types/marker/IMarkerInfo';
import moveMarkerPane from '../shared/moveMarkerPane';
import setZoom from '../shared/setZoom';
import buildCluster from './cluster/buildCluster';
import calculator from './cluster/calculator';
import addEventListenerToMapFullyLoaded from './event-listeners/addEventListenerToMapFullyLoaded';
import addEventListenerToStreetViewModeChanged from './event-listeners/addEventListenerToStreetViewModeChanged';
import buildMarkerSvg from './marker/buildMarkerSvg';
import getMarkerPosition from './marker/getMarkerPosition';
import getMarkerZIndex from './marker/getMarkerZIndex';
import markerClicked from './marker/markerClicked';

const getMapFunctions = ({
  mapState, markersInnerState, config, mapRef,
}: IMapSzukajServiceConfig) => ({
  buildCluster: (): IClusterDomInfo => buildCluster(),
  getMarkerZIndex: (marker: BloczekMarker): number => getMarkerZIndex(marker, { markersInnerState } as IMapSzukajServiceConfig),
  buildMarkerSvg: (marker: BloczekMarker, activeMarker: Ref<BloczekMarker>): IMarkerIcon => buildMarkerSvg(marker, activeMarker),
  getMarkerPosition(marker: BloczekMarker): IGoogleMapPosition {
    return getMarkerPosition(marker);
  },
  calculator(gmapMarkers: any[]): IClusterCalculatorDefinition {
    return calculator(gmapMarkers, mapState);
  },
  setZoom(value: number = 1) {
    return setZoom({ config, mapRef } as IMapSzukajServiceConfig, value);
  },
  markerClicked: (marker: BloczekMarker): void => {
    const markerInfo: IMarkerInfo<BloczekMarker> = {
      marker,
      mapRef,
      activeMarker: toRef(markersInnerState, 'activeMarker'),
    };

    markerClicked(markerInfo);
  },

  mapIsFullyLoadedAndStreetViewIsUnvisible: (): boolean => config.isFullyLoaded && !config.streetViewIsVisible,
  hasAtOneLeastWithCoords(): boolean {
    return mapState?.markers?.find((x) => x.DlugoscGeo != null && x.SzerokoscGeo != null) !== undefined;
  },
  init: async (serviceConfig: IMapSzukajServiceConfig): Promise<void> => {
    const gmap = await mapRef.value.$mapPromise;
    const eventListenerParam: IMapEventListenerParams<IMapSzukajServiceConfig> = { serviceConfig, gmap };

    addEventListenerToStreetViewModeChanged(eventListenerParam);
    moveMarkerPane(gmap);
    addEventListenerToMapFullyLoaded(eventListenerParam);
  },
});

export default getMapFunctions;
